import requestAPI from './instance'
import axios from 'axios'

/**
 * @description Promise to login
 * @param {object} credentials - Object data with form values {@user, @password and @code}
 * @returns {Promise} The Promise object
 */
export const login = async (credentials) => {
  const login = await axios({
    method: 'post',
    url: `${process.env.REACT_APP_API_URL}/login`,
    data: credentials
  })
  return login
}

/**
 * @description Promise to logout
 * @returns {Promise} The Promise object
 */
export const logout = async () => {
  return await requestAPI.get(`/logout`)
}
